module.exports = __webpack_public_path__ + "img/adult.7e525cf4.jpg";